import { render, staticRenderFns } from "./moreCompletion.vue?vue&type=template&id=58b515c1&scoped=true&"
import script from "./moreCompletion.vue?vue&type=script&lang=ts&"
export * from "./moreCompletion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b515c1",
  null
  
)

export default component.exports